import { TOUR_V2_FEMALE_TRAVELLER_TITLES, TOUR_V2_MALE_TRAVELLER_TITLES } from 'constants/tours'

export default function deduceGenderFromTitle(title: App.Title): App.Gender {
  if (TOUR_V2_FEMALE_TRAVELLER_TITLES.includes(title)) {
    return 'Female'
  }

  if (TOUR_V2_MALE_TRAVELLER_TITLES.includes(title)) {
    return 'Male'
  }

  return 'Other'
}
